import React, { useRef } from "react";
import Modal from "react-bootstrap/Modal";

import "./Service_History_modal.css";
import { Table } from "react-bootstrap";

const Service_History_modal = ({ show, onHide, setErr, history }) => {

  const formatMonth = (value) => {
    if (!value) return "";

    let date;

    if (value.length === 7) {
      // Case: YYYY-MM → default day = 01
      const [year, month] = value.split("-");
      date = new Date(year, month - 1, 1);
    } else {
      // Case: YYYY-MM-DD
      date = new Date(value);
    }

    return date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <Modal
      className="common_modal Service_History_modal"
      centered
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={onHide}
      size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Service History</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row mt-3">
          <div className="data table-responsive">
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Start Month</th>
                  <th>End Month</th>
                  <th>Extended on Date</th>
                </tr>
              </thead>

              <tbody>
                {history.map((d, index) => (
                  <tr key={index}>
                    <td>{index + 1}.</td>
                    <td>{formatMonth(d.start_month)}</td>
                    <td>{formatMonth(d.end_month)}</td>
                    <td>{formatMonth(d.createdAt)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>

        <div className="btn_holder"></div>
      </Modal.Body>
    </Modal>
  );
};

export default Service_History_modal;
